import React from "react";
import NewsletterSixteen from "../component/NewsletterSixteen";

function NewsletterSixteenContainer() {
  return <NewsletterSixteen />;
}

export default NewsletterSixteenContainer;
